// choices/paletteChoices.js
import { images } from "../../components/utility/imageImports";

const paletteChoicesSrb = [
  {
    label: "Плава",
    value: "blues",
    imageUrl: images["blues.png"],
  },

  {
    label: "Зелена",
    value: "greens",
    imageUrl: images["greens.png"],
  },

  {
    label: "Жута",
    value: "yellows",
    imageUrl: images["yellows.png"],
  },

  {
    label: "Црвена",
    value: "reds",
    imageUrl: images["reds.png"],
  },

  {
    label: "Наранџаста",
    value: "oranges",
    imageUrl: images["oranges.png"],
  },

  {
    label: "Љубичаста",
    value: "violets",
    imageUrl: images["violets.png"],
  },

  {
    label: "Бела",
    value: "whites",
    imageUrl: images["whites.png"],
  },

  {
    label: "Сива",
    value: "grays",
    imageUrl: images["grays.png"],
  },

  {
    label: "Браон",
    value: "browns",
    imageUrl: images["browns.png"],
  },
];

export default paletteChoicesSrb;
